import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.18 9.198l2.66-2.62-7.938-.035c-.511-.003-.923-.417-.92-.926.002-.508.418-.919.928-.916l7.936.036L7.221 2.09c-.359-.361-.356-.944.006-1.302.363-.358.948-.355 1.307.006l4.315 4.343c.294.297.292.775-.006 1.069l-4.362 4.3c-.363.358-.948.356-1.307-.006-.36-.361-.357-.944.006-1.302z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", props, _ref);
};
export default __webpack_public_path__ + "static/media/arrow-right.911a6ff5.svg";
export { SvgComponent as ReactComponent };